import React, { useState, useEffect } from "react";
import { authenticatedFetch } from "../../utils/api";
import { API_HOST } from "../../utils/constants";
import NodeCanvas from "./NodeCanvas";

const CanvasMode = ({ projectId, episodeId }) => {
  const [canvasData, setCanvasData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 加载画布数据：优先按集（单集工作台 tab 旧入口），否则按项目（一个项目一张画布）
  useEffect(() => {
    let cancelled = false;

    if (!episodeId && !projectId) {
      setCanvasData(null);
      setLoading(false);
      return undefined;
    }

    const loadCanvasData = async () => {
      try {
        setLoading(true);
        const url = episodeId
          ? `${API_HOST}/api/canvas/episode/${episodeId}`
          : `${API_HOST}/api/canvas/project/${projectId}`;
        const data = await authenticatedFetch(url);
        if (!cancelled) setCanvasData(data);
      } catch (error) {
        if (!cancelled) console.error("加载画布数据失败:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCanvasData();
    return () => {
      cancelled = true;
    };
  }, [episodeId, projectId]);

  // 保存节点
  const handleSaveNode = async (node) => {
    try {
      const saved = await authenticatedFetch(`${API_HOST}/api/canvas/node`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(node),
      });
      return saved;
    } catch (error) {
      console.error("保存节点失败:", error);
      throw error;
    }
  };

  // 删除节点
  const handleDeleteNode = async (nodeId) => {
    try {
      await authenticatedFetch(`${API_HOST}/api/canvas/node/${nodeId}`, {
        method: "DELETE",
      });
    } catch (error) {
      console.error("删除节点失败:", error);
      throw error;
    }
  };

  // 保存连接
  const handleSaveConnection = async (connection) => {
    try {
      const saved = await authenticatedFetch(`${API_HOST}/api/canvas/connection`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(connection),
      });
      return saved;
    } catch (error) {
      console.error("保存连接失败:", error);
      throw error;
    }
  };

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
        <div className="text-sm" style={{ color: 'var(--color-text-muted)' }}>加载画布中...</div>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex flex-col" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
      <div className="flex-1 min-h-0">
        <NodeCanvas
          canvasId={canvasData?.id}
          projectId={projectId}
          episodeId={episodeId}
          nodes={canvasData?.nodes || []}
          connections={canvasData?.connections || []}
          onSaveNode={handleSaveNode}
          onDeleteNode={handleDeleteNode}
          onSaveConnection={handleSaveConnection}
        />
      </div>
    </div>
  );
};

export default CanvasMode;
